import "../../css/skeletons/RecurrenceTimelineSkeleton.css";

/**
 * Skeleton for the ODRecurrenceTimeline widget
 */
export const RecurrenceTimelineSkeleton = () => {
  return (
    <div className="odrts-container" aria-hidden="true">
      {/* Scroll area */}
      <div className="odrts-track">
        {/* Background line */}
        <span className="odrts-line" />

        {[0, 1, 2].map((i) => (
          <div key={i} className="odrts-item">
            {/* Responsible of the node */}
            <span className="odrts-chip odrts-responsible" />

            {/* Circle node */}
            <span className="odrts-chip odrts-dot" />

            {/* Date / completed-date chips */}
            <div className="odrts-label">
              <span className="odrts-chip odrts-date-lbl" />
              <span className="odrts-chip odrts-date-val" />
              <span className="odrts-chip odrts-date-lbl" />
              <span className="odrts-chip odrts-date-val" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};